<div class="content">
    <header class="header">
        <ui-logo
            [small]="true"
            class="logo"></ui-logo>
        <h1>Profile client</h1>
        <p class="subtitle">Pick a flow to exercise.</p>
    </header>

    <nav class="grid">
        <a
            routerLink="/login"
            uiCard
            [hoverable]="true"
            class="card"
            aria-label="Password login via full-page Auth0 redirect">
            <div
                uiCardHeader
                class="card-header">
                <ui-svg-icon
                    icon="none"
                    nuiIcon="login"
                    [size]="'md'"></ui-svg-icon>
                <h2 uiCardTitle>Password sign-in</h2>
            </div>
            <div
                uiCardContent
                class="card-content">
                <ui-label
                    class="path"
                    size="sm"
                    weight="bold"
                    >/login</ui-label
                >
                <p>Full-page Auth0 redirect. Primary sign-in flow.</p>
            </div>
        </a>
        <a
            routerLink="/login/test"
            uiCard
            [hoverable]="true"
            class="card"
            aria-label="Password login via Auth0 popup">
            <div
                uiCardHeader
                class="card-header">
                <ui-svg-icon
                    icon="none"
                    nuiIcon="open_in_new"
                    [size]="'md'"></ui-svg-icon>
                <h2 uiCardTitle>Popup sign-in</h2>
            </div>
            <div
                uiCardContent
                class="card-content">
                <ui-label
                    class="path"
                    size="sm"
                    weight="bold"
                    >/login/test</ui-label
                >
                <p>Auth0 popup flow. Test the password connection in place.</p>
            </div>
        </a>
        <a
            routerLink="/test-sso"
            uiCard
            [hoverable]="true"
            class="card"
            aria-label="Test SSO sign-in with a forced re-authentication">
            <div
                uiCardHeader
                class="card-header">
                <ui-svg-icon
                    icon="none"
                    nuiIcon="verified_user"
                    [size]="'md'"></ui-svg-icon>
                <h2 uiCardTitle>SSO test</h2>
            </div>
            <div
                uiCardContent
                class="card-content">
                <ui-label
                    class="path"
                    size="sm"
                    weight="bold"
                    >/test-sso</ui-label
                >
                <p>Forces a fresh sign-in and reports the connection it came back on.</p>
            </div>
        </a>
    </nav>
</div>
